import {
  Box,
  Group,
  Paper,
  Stack,
  Title,
  rem,
  Anchor,
  Text,
  Button,
  TextInput,
  CopyButton,
  Divider,
  ThemeIcon,
} from "@mantine/core";
import {
  IconBrandTelegram,
  IconClock,
  IconCopy,
  IconMail,
  IconMessage,
} from "@tabler/icons-react";

import React from "react";

const ContactContainer: React.FC = () => {
  return (
    <Paper>
      <Stack>
        <Title order={1}>Contact The Megalith Node</Title>
        <Text span size="md">
          Please reach out for any questions, comments, or if you have a
          question about the Lightning Network.
        </Text>
        <Text size="md">
          To send us a public message, use Nostr.{" "}
          <Anchor href="https://primal.net/p/nprofile1qqsf07zg4hxyccnkdp07fppxmetpfzru3fg6mgzx3nk8r7af8qnjjyg76vulm">
            This is our Nostr profile
          </Anchor>
          . Simply write a note, and be sure to tag @Rizful.com.
        </Text>
        <Text>
          If you're not already on Nostr,{" "}
          <Anchor href="https://rizful.com/get_on_nostr_today">
            follow this guide to get started
          </Anchor>
          .
        </Text>

        <Box
          p="md"
          style={{
            border: "1px solid var(--mantine-color-blue-7)",
            borderRadius: rem(8),
            background: "var(--mantine-color-dark-6)",
          }}
        >
          <Stack gap="sm">
            <Group align="flex-start" wrap="nowrap">
              <ThemeIcon size="lg" radius="xl" color="blue" variant="filled">
                <IconClock size={20} />
              </ThemeIcon>
              <Box style={{ minWidth: 0 }}>
                <Title order={3}>Fastest private contact</Title>
                <Text size="md">
                  Use Telegram or Signal for time-sensitive messages. Replies
                  usually arrive in 1 to 12 hours, depending on your time zone.
                </Text>
              </Box>
            </Group>
            <Group>
              <Button
                component="a"
                href="https://t.me/megalith_node"
                leftSection={<IconBrandTelegram />}
              >
                Send Telegram Message
              </Button>
              <Button
                component="a"
                href="https://signal.me/#u/megalith.16"
                leftSection={<IconMessage />}
                variant="light"
              >
                Send Signal Message
              </Button>
            </Group>
          </Stack>
        </Box>
        <Group align="flex-start" wrap="nowrap">
          <ThemeIcon size="lg" radius="xl" color="gray" variant="light">
            <IconMail size={20} />
          </ThemeIcon>
          <Box style={{ minWidth: 0 }}>
            <Text fw={600}>Email is best for non-urgent messages.</Text>
            <Text size="md">
              For email contacts, expect a reply in 48 to 72 hours.
            </Text>
          </Box>
        </Group>
        <TextInput
          radius="md"
          mt="8"
          mb="8"
          maw="60%"
          readOnly
          value={"info@megalithic.me"}
          onFocus={(e) => e.currentTarget.select()}
        />
        <Box maw="md">
          <CopyButton value="info@megalithic.me">
            {({ copied, copy }) => (
              <Button
                leftSection={<IconCopy />}
                color={copied ? "teal" : "blue"}
                onClick={copy}
              >
                {copied ? "Copied!" : "Copy email address"}
              </Button>
            )}
          </CopyButton>
        </Box>
        <Divider mt="lg" />
        <Title order={3}>Who started the Megalith Node?</Title>
        <Text span size="md">
          Hi. We're software developers and Bitcoiners with an interest in
          ethical financial services. We like working on interesting projects
          that can benefit everyone who uses Bitcoin. Do get in touch if you're
          looking for help with something.
        </Text>
      </Stack>
    </Paper>
  );
};

export default ContactContainer;
